import Vue from 'vue';
import App from './app.vue';
import router from './router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import './styles/styles.scss';
import { addIcons } from './icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap';
addIcons();
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.config.productionTip = false;
router.afterEach(() => {
    window.scrollTo(0, 0);
});
new Vue({
    created() {
        // 初始化AOS，在移动端（宽度小于992px）禁用动画
        const initAOS = () => {
            const isMobile = window.innerWidth < 992;
            AOS.init({
                disable: isMobile ? true : 'mobile',
                duration: 600,
                once: true,
            });
        };
        initAOS();
        let wasMobile = window.innerWidth < 992;
        // 等待关键图片加载完成后刷新AOS，确保动画效果正常
        const headerImages = [
            '/assets/img/homepage-main.png',
            '/assets/img/product1.png',
            '/assets/img/product2.png',
            '/assets/img/product3.png'
        ];
        let loadedCount = 0;
        const totalImages = headerImages.length;
        headerImages.forEach((src) => {
            const img = new Image();
            img.onload = () => {
                loadedCount++;
                if (loadedCount === totalImages) {
                    // 所有关键图片加载完成后刷新AOS
                    AOS.refresh();
                }
            };
            img.src = src;
        });
        // 监听窗口大小改变，在移动端和桌面端之间切换时重新初始化AOS
        let resizeTimer = null;
        window.addEventListener('resize', () => {
            if (resizeTimer) {
                clearTimeout(resizeTimer);
            }
            resizeTimer = window.setTimeout(() => {
                const isMobileNow = window.innerWidth < 992;
                // 如果从移动端切换到桌面端，或从桌面端切换到移动端，需要重新初始化AOS
                if (wasMobile !== isMobileNow) {
                    // 清除现有的AOS实例
                    AOS.refreshHard();
                    // 重新初始化AOS
                    initAOS();
                    // 强制刷新所有元素，确保内容可见
                    setTimeout(() => {
                        AOS.refresh();
                        // 确保所有带有data-aos的元素都可见
                        const aosElements = document.querySelectorAll('[data-aos]');
                        aosElements.forEach((el) => {
                            el.style.opacity = '1';
                            el.style.transform = 'none';
                        });
                        // 再次刷新确保动画正常
                        AOS.refresh();
                    }, 50);
                }
                else {
                    // 只是窗口大小改变但没有跨越断点，只需要刷新
                    AOS.refresh();
                }
                wasMobile = isMobileNow;
            }, 100);
        });
    },
    router,
    render: h => h(App),
}).$mount('#app');
